import { SVGProps, Ref, forwardRef } from 'react';

export const DashedSquareOutOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M15 3.8h5.2V9H22V2h-7z" fill="currentColor" />
                <path d="M9 3.8V2H2v7h1.8V3.8z" fill="currentColor" />
                <path d="M3.8 15H2v7h7v-1.8H3.8z" fill="currentColor" />
                <path d="M15 20.2V22h7v-7h-1.8v5.2z" fill="currentColor" />
            </g>
        </svg>
    )
);
DashedSquareOutOutlinedSize24Glyph.displayName = 'DashedSquareOutOutlinedSize24Glyph';
